import { useHoverCycle } from "@/shared/lib/hoverCycle";

/** Bir nechta rasmni ketma-ket ko'rish: katta rasm, ‹ › tugmalari va kichik rasmlar qatori. */
/** Rasmlar yonma-yon turadi; `index` o'zgarganda lenta yon tomonga sekin suriladi. */
export function SlideTrack({ images, index, alt = "" }: { images: string[]; index: number; alt?: string }) {
  return (
    <div className="slide-track" style={{ transform: `translateX(-${index * 100}%)` }}>
      {images.map((src, i) => (
        <img key={src} src={src} alt={i === index ? alt : ""} loading={i === 0 ? "eager" : "lazy"} />
      ))}
    </div>
  );
}

export function ImageGallery({ images, alt }: { images: string[]; alt: string }) {
  const { index: current, setIndex, hoverProps } = useHoverCycle(images);
  if (images.length === 0) return null;
  const go = (step: number) => setIndex((current + step + images.length) % images.length);
  return (
    <div className="img-gallery">
      <div className="img-gallery-main" {...hoverProps}>
        <SlideTrack images={images} index={current} alt={alt} />
        {images.length > 1 ? (
          <>
            <button type="button" className="img-gallery-nav is-prev" aria-label="‹" onClick={() => go(-1)}>
              ‹
            </button>
            <button type="button" className="img-gallery-nav is-next" aria-label="›" onClick={() => go(1)}>
              ›
            </button>
            <span className="img-gallery-count">
              {current + 1} / {images.length}
            </span>
          </>
        ) : null}
      </div>
      {images.length > 1 ? (
        <div className="img-gallery-thumbs">
          {images.map((src, i) => (
            <button
              key={src}
              type="button"
              className={i === current ? "is-on" : undefined}
              aria-label={`${i + 1}`}
              onClick={() => setIndex(i)}
            >
              <img src={src} alt="" loading="lazy" />
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}

/** Ro'yxat qatoridagi kichik rasm: ustiga kelinganda boshqa rasmlarga o'tadi. */
export function ProductThumb({ images }: { images: string[] }) {
  const { index, hoverProps } = useHoverCycle(images);
  return (
    <span className="cell-thumb" {...hoverProps}>
      <SlideTrack images={images} index={index} />
    </span>
  );
}
